/**
 * Single source of truth for the physical-performance metrics.
 *
 * Centralises what used to be duplicated across PlayerPhysicalPerformanceStats
 * and PhysicalPerformanceTrendsSimple: the validity check, validation ranges,
 * trend direction (lower-vs-higher is better), thresholds, units and chart-axis
 * labels. The entry form, validation, trend logic and charts all read from here.
 */

export const METRICS = {
  tenM_sprint_time: {
    label: "10m sprint",
    unit: "s",
    lowerIsBetter: true,
    threshold: 0.05,
    min: 1,
    max: 6,
    axis: "Sprint Time (seconds)",
  },
  fortyM_sprint_time: {
    label: "30m sprint",
    unit: "s",
    lowerIsBetter: true,
    threshold: 0.05,
    min: 2,
    max: 12,
    axis: "Sprint Time (seconds)",
  },
  cuntermovement_jump: {
    label: "Countermovement jump",
    unit: "cm",
    lowerIsBetter: false,
    threshold: 2,
    min: 5,
    max: 90,
    axis: "Jump Height (cm)",
  },
  reactive_strength_index: {
    label: "Reactive strength index",
    unit: "",
    lowerIsBetter: false,
    threshold: 0.1,
    min: 0.1,
    max: 6,
    axis: "RSI Score",
  },
  thirty_15_intermittent_fitness_test: {
    label: "Fitness test",
    unit: "",
    lowerIsBetter: true,
    threshold: 0.5,
    min: 5,
    max: 35,
    axis: "Fitness Score",
  },
  height: {
    label: "Height",
    unit: "cm",
    lowerIsBetter: false,
    threshold: 0.5,
    min: 100,
    max: 230,
    axis: "Height (cm)",
  },
  weight: {
    label: "Weight",
    unit: "kg",
    lowerIsBetter: false,
    threshold: 0.5,
    min: 20,
    max: 150,
    axis: "Weight (kg)",
  },
};

/** Maps the trends chart selector value ("1"–"6") to its metric field. */
export const CHART_TYPE_FIELD = {
  1: "tenM_sprint_time",
  2: "cuntermovement_jump",
  3: "reactive_strength_index",
  4: "thirty_15_intermittent_fitness_test",
  5: "height",
  6: "weight",
  7: "fortyM_sprint_time",
};

/** A value counts as a real measurement: numeric and greater than zero. */
export function isValidValue(value) {
  const numValue = parseFloat(value);
  return (
    value !== null &&
    value !== undefined &&
    value !== "" &&
    !isNaN(numValue) &&
    numValue > 0
  );
}

export function fieldForChartType(chartType) {
  return CHART_TYPE_FIELD[chartType] || null;
}
